import { RefreshCcw, Download, XCircle } from "lucide-react";
import DeclinedItemsList from "./DeclinedItemsList";

// DeclinedProposalView — shown when a plan is Rejected (patient declined
// the whole proposal). Replaces the empty appointment board with the
// on-record list of what was turned down, plus a primary
// "Revise & re-propose" that spins a fresh Draft carrying the procedures
// (reuses the existing revise action).

function formatPHP(centavos) {
  if (!Number.isFinite(centavos)) return "—";
  return `₱${Math.round(centavos / 100).toLocaleString()}`;
}

export default function DeclinedProposalView({ plan, onRevise, onDownloadPdf }) {
  const items = plan?.items ?? [];
  const declinedTotal = items
    .filter((it) => it.status === "Declined")
    .reduce((s, it) => s + (Number(it.fee_centavos) || 0), 0);

  return (
    <div data-testid="declined-proposal-view" className="space-y-3">
      <p className="text-sm text-slate-500 inline-flex items-center gap-1.5">
        <XCircle className="w-4 h-4 text-rose-500" /> Patient declined this proposal.
      </p>
      <p className="text-[11px] font-semibold uppercase tracking-wider text-slate-400">Declined procedures</p>
      <DeclinedItemsList items={items} />
      <div className="flex items-center justify-between gap-3 pt-3 border-t border-slate-100">
        <span className="text-sm text-slate-600">
          Declined total{" "}
          <span data-testid="declined-total" className="text-slate-900 font-medium tabular-nums">{formatPHP(declinedTotal)}</span>
        </span>
        <div className="flex gap-2">
          <button
            type="button"
            onClick={() => onDownloadPdf?.(plan.id)}
            data-testid="declined-pdf"
            className="inline-flex items-center gap-1.5 px-3 py-2 rounded-lg border border-slate-200 text-sm hover:border-slate-400"
          >
            <Download className="w-3.5 h-3.5" /> PDF
          </button>
          <button
            type="button"
            onClick={() => onRevise?.(plan.id)}
            data-testid="declined-revise"
            className="inline-flex items-center gap-2 px-4 py-2 rounded-xl bg-slate-900 text-white text-sm font-semibold hover:bg-slate-800"
          >
            <RefreshCcw className="w-3.5 h-3.5" /> Revise &amp; re-propose
          </button>
        </div>
      </div>
    </div>
  );
}
